module.exports = __webpack_public_path__ + "static/media/landing.7aafa309.jpeg";